import {Action, Module, Mutation} from "vuex-module-decorators";
import store, {currentUserModule} from "@/store";
import BaseModule from "@/store/modules/BaseModule";
import {MdbsCore} from "@/api/tsclient";
import NtdInstituteDto = MdbsCore.NtdInstituteDto;
import Rights = MdbsCore.Rights;
import INtdInstituteCreateDto = MdbsCore.INtdInstituteCreateDto;
import NtdInstituteCreateDto = MdbsCore.NtdInstituteCreateDto;
import INtdInstituteUpdateDto = MdbsCore.INtdInstituteUpdateDto;
import NtdInstituteUpdateDto = MdbsCore.NtdInstituteUpdateDto;
import INtdInstituteDeleteDto = MdbsCore.INtdInstituteDeleteDto;
import NtdInstituteDeleteDto = MdbsCore.NtdInstituteDeleteDto;

const ntdInstituteClient = new MdbsCore.NtdInstituteClient();

@Module({namespaced: true, name: 'ntdInstitutes', store: store})
export default class NtdInstitutesModule extends BaseModule {

    private _ntdInstitutes: Array<NtdInstituteDto> = new Array<MdbsCore.NtdInstituteDto>();

    public get ntdInstitutes(): Array<NtdInstituteDto> {
        return this._ntdInstitutes;
    }

    @Mutation
    setNtdInstitutes(ntdInstitutes: Array<NtdInstituteDto>) {
        this._ntdInstitutes = ntdInstitutes;
    }

    @Mutation
    clearNtdInstitutes() {
        this.ntdInstitutes?.clear();
    }

    @Action({rawError: true})
    async isOnline() {
        return true; //TODO
    }

    @Action({rawError: true})
    async loadAll(includeDeleted?: boolean) {
        this.startLoading();
        this.clearNtdInstitutes();
        await this.execute(async () => {
            if(currentUserModule.hasRight(Rights.NtdInstituteGetAllCmd)){
                this.setNtdInstitutes(await ntdInstituteClient.getAllNtdInstitutes(includeDeleted));
            }
            else if(currentUserModule.hasRight(Rights.NtdInstituteGetMyCmd)){
                this.setNtdInstitutes(await ntdInstituteClient.getMyNtdInstitutes(includeDeleted));
            }
            else{
                this.clearNtdInstitutes();
            }
        });

        this.stopLoading();
    }

    @Action({rawError: true})
    async createNtdInstitute(institute: INtdInstituteCreateDto) {
        this.startLoading();

        await this.execute(async () => {
            await ntdInstituteClient.create(new NtdInstituteCreateDto(institute));
            await this.loadAll();
        });

        this.stopLoading();
    }

    @Action({rawError: true})
    async updateNtdInstitute(institute: INtdInstituteUpdateDto) {
        this.startLoading();

        await this.execute(async () => {
            await ntdInstituteClient.update(new NtdInstituteUpdateDto(institute));
            await this.loadAll();
        });

        this.stopLoading();
    }

    @Action({rawError: true})
    async deleteNtdInstitute(institute: INtdInstituteDeleteDto) {
        this.startLoading();

        await this.execute(async () => {
            await ntdInstituteClient.delete(new NtdInstituteDeleteDto(institute));
            await this.loadAll();
        });

        this.stopLoading();
    }
}